import highcharts from 'highcharts';
import highcharts3d from 'highcharts/highcharts-3d';
const initHighcharts = () => highcharts3d(highcharts);

export { initHighcharts };
